<span [class]="badgeClass()">
  @if (isInProgress()) {
    <ocp-themed-icon name="refresh-circled.svg" [size]="14" />
  }
  @if (isUploaded()) {
    <ocp-themed-icon name="checkmark.svg" [size]="14" />
  }
  {{ statusLabel() }}
  @if (showPercentage()) {
    {{ percentage() }}%
  }
</span>
